<template>
  <v-container class="top-container primary-bg">
    <v-row class="top-section justify-center">
      <v-col cols="12" md="5" sm="6" class="top-content text-center text-md-start pr-12">
        <h1 class="text-h4 text-white pb-3">{{ lang.top_section.caption }}</h1>
        <h2 class="text-h6 font-weight-regular text-white">{{ lang.top_section.subtitle }}</h2>
      </v-col>
      <v-col cols="8" md="5" sm="6" class="top-image header-image-wrapper ma-3 ma-md-0" :class="{ loaded: showGradient }">

        <v-img eager :src="productImage" @error="errorProductImage" class="ma-auto" data-aos-once="true"
               data-aos="zoom-out" data-aos-offset="300" data-aos-duration="600" style="opacity: 1!important;border-radius: 12px;"
               data-aos-easing="linear"></v-img>
          <div class="image-gradient"></div>

      </v-col>
    </v-row>
    <v-img eager class="top-wave" :src="topWave"></v-img>
  </v-container>
</template>

<style>
.header-image-wrapper {
  display: flex;
  position: relative;
  overflow: hidden;
  justify-content: center;
  padding: 0;
}

.header-image-wrapper img {
  display: block;
  width: 100%;
  height: auto;
}

.image-gradient {
  position: absolute;
  bottom: 0;
  width: 100%;
  max-width: 600px;
  height: 100px;
  background: linear-gradient(to bottom, rgba(255,255,255,0) 0%, #fff 100%);
  border-radius: 0 0 10px 10px;
  opacity: 0;
  transition: opacity 0.5s ease-in;
  transition-delay: 0.5s;
}

.header-image-wrapper.loaded .image-gradient {
  opacity: 1;
}

.top-container {
  position: relative;
  padding-top: 56px;
  padding-bottom: 0;
}

.top-wave {
  transform-origin: bottom;
  animation: animateWave 2000ms cubic-bezier(0.23, 1, 0.32, 1) forwards;
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  max-width: unset;
}

.top-content, .top-image {
  z-index: 1;
  align-self: center;
}

.top-content {
  max-width: 400px;
}

.top-image .v-img {
  max-width: 600px;
}

.v-toolbar-title__placeholder {
  overflow: visible;
}

@keyframes animateWave {
  0% {
    transform: scale(1, 0);
  }
  100% {
    transform: scale(1, 1);
  }
}

@media (max-width: 959px) {
  .top-container {
    padding-top: 120px;
  }

  .v-toolbar {
    box-shadow: 0px 2px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 10px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12)) !important;
  }
}

@media (min-width: 960px) {
  .top-container {
    min-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .top-section {
    text-align: start;
    padding: 90px 32px 68px 48px;
  }

  .top-content {
    padding-top: 80px;
    padding-bottom: 50px;
  }

  .top-image {
    display: flex;
    align-items: center;
  }

  .top-image .v-image {
    max-width: 100%;
  }

  .v-toolbar {
    height: auto !important;
    transition: all 300ms ease-in-out;
    -webkit-transition: all 300ms ease-in-out;
    padding: 36px 16px;
  }

  .v-toolbar-items {
    height: 36px !important;
  }

  .v-toolbar-items .v-btn__content, .v-toolbar .v-toolbar-title {
    color: white;
  }

  .v-toolbar.is-scrolled .v-toolbar-items .v-btn__content, .v-toolbar.is-scrolled .v-toolbar-title {
    color: black;
  }

  .v-toolbar.is-scrolled {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .v-toolbar__content {
    height: auto !important;
  }

  .v-toolbar:not(.is-scrolled) {
    background: transparent !important;
  }
}

@media (min-width: 1614px) {
  .top-section {
    padding: 120px 32px 120px 64px;
  }

  .top-content {
    padding-top: 200px;
    padding-left: 180px;
    padding-right: 50px;
    padding-bottom: 100px;
    max-width: 800px;
  }

  .v-toolbar__content {
    padding-left: 80px;
    padding-right: 80px;
  }
}
</style>

<script>
import lang from '@/lang/lang.js'

export default {
  data() {
    return {
      lang: lang,
      productImage: '/images/topSection/topSection.webp',
      errorProductImage: '/images/topSection/topSection.jpg',
      topWave: '/images/topSection/topWave.svg',
      showGradient: false, // hier ins data()
    }
  },
  mounted() {
    this.$nextTick(() => {
        this.showGradient = true
    })
  }
}
</script>